<template>
  <div class="gf_pricing__enjoy__box gf_pricing__container">
    <div class="gf_pricing__enjoy__left">
      {{ $t("dataNewPlan.enjoy.content1") }}
    </div>
    <div class="gf_pricing__enjoy__right">
      <div class="gf_pricing__enjoy__right__section">
        <div class="gf_pricing__enjoy__right__section-icon">
          <img src="../assets/pricing-credit-card.svg" alt="">
        </div>
        <div class="gf_pricing__enjoy__right__section-info">
          <div class="gf_pricing__enjoy__right__section-info--title">
            {{ $t("dataNewPlan.enjoy.content2") }}
          </div>
          <div class="gf_pricing__enjoy__right__section-info--desc" v-html="$t('dataNewPlan.enjoy.content3')"></div>
        </div>
      </div>
      <div class="gf_pricing__enjoy__right__section">
        <div class="gf_pricing__enjoy__right__section-icon">
          <img src="../assets/pricing.svg">
        </div>
        <div class="gf_pricing__enjoy__right__section-info">
          <div class="gf_pricing__enjoy__right__section-info--title">
            {{ $t("dataNewPlan.enjoy.content5") }} 
          </div>
          <div class="gf_pricing__enjoy__right__section-info--desc" v-html="$t('dataNewPlan.enjoy.content6')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingEnjoy",
  computed: {},
};
</script>

<style lang="scss" scoped>
.gf_pricing__enjoy {
  &__box {
    display: flex;
    flex-wrap: nowrap;
  }
  &__left {
    width: 356px;
    padding-right: 110px;
    font-weight: 600;
    font-size: 24px;
    line-height: 150%;
    color: map-get($text-light-mode, "high-contrast");
    display: flex;
    align-items: center;
    @media screen and (max-width: 1230px){
      padding-right: 48px;
      width: 297px;
    }
  }
  &__right {
      flex: 1;
      display: flex;
      &__section{
        width: 50%;
        display: flex;
        @media screen and (max-width: 1230px){
          flex-direction: column;
        }
        &:first-child {
          padding-right: 26px;
          @media screen and (max-width: 1230px){
            padding-right: 8px;
          }
        }
        &:last-child {
          padding-left: 36px;
          padding-right: 8px;
          @media screen and (max-width: 1230px){
            padding-left: 8px;
            padding-right: 8px;
          }
        }
        &-icon {
          width: 32px;
          height: 32px;
          margin-right: 16px;
          @media screen and (max-width: 1230px){
            margin-bottom: 8px;
          }
        }
        &-info {
          flex: 1;
          &--title {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: map-get($text-light-mode, "high-contrast");
            margin-bottom: 4px;
          }
          &--desc {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: map-get($text-light-mode, "low-contrast");;
            a {
              color: map-get($primary-blue, "300");
              &:hover {
                color: map-get($primary-blue, "325");
              }
            }
          }
        }
      }
  }
}
</style>
